import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Reveal, SectionHeading } from '../components/Reveal';
import { FAQS } from '../lib/site';

export const Faq = () => (
  <section className="py-20 lg:py-28" id="faq" data-testid="faq-section">
    <div className="container-x grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
      <div>
        <SectionHeading
          eyebrow="FAQ"
          title="Frequently Asked Questions"
          sub="Everything you need to know about CapableBee."
        />
        <Reveal delay={0.15}>
          <div className="mt-8 rounded-3xl border border-brand-line bg-brand-iceSoft p-7">
            <p className="font-bold text-brand-navy">Still have questions?</p>
            <p className="mt-2 text-sm text-slate-600">
              Book a demo today and see how CapableBee can turn conversations into leads.
            </p>
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-navy px-5 py-2.5 text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:shadow-lift"
            >
              Contact Us
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="rounded-2xl border border-brand-line bg-white px-6 shadow-card"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left text-base font-bold text-brand-navy hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
